import { useCallback, useState } from 'react';
import type { FunctionComponent } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Dialog, { Clip, Next } from '../../components/molecules/Dialog';
import DialogHeader, {
	Highlight
} from '../../components/molecules/DialogHeader';
import Label from '../../components/atoms/Label';
import TextField from '../../components/atoms/TextField';
import {
	MAX_PLAYER_NAME_LENGTH,
	cleanupPlayerName
} from '../../data/PlayerName';

interface Props {
	defaultName?: string;
	onNext: (name: string) => void;
}

const PlayerDialog: FunctionComponent<Props> = (props: Props) => {
	const { defaultName = '', onNext } = props;
	const [name, setName] = useState(defaultName);
	const { t } = useTranslation();

	const handleNameChange = useCallback(
		(newName: string) => {
			setName(cleanupPlayerName(newName));
		},
		[setName]
	);

	return (
		<Dialog>
			<Clip>
				<DialogHeader>
					<Trans>introduction.player.welcome</Trans>
					<br />
					<Highlight>{t('app_name')}</Highlight>
				</DialogHeader>
				<Label bold light position="absolute" left="45%" bottom="40%">
					<Trans>introduction.player.your_name</Trans>
				</Label>
				<TextField
					value={name}
					onChange={handleNameChange}
					maxLength={MAX_PLAYER_NAME_LENGTH}
					autoFocus
					position="absolute"
					left="45%"
					top="60%"
					width="40%"
				/>
				<Label
					light
					small
					position="absolute"
					left="45%"
					top="calc(60% + 9.2vmin)"
				>
					<Trans>introduction.player.name_usage</Trans>
				</Label>
			</Clip>
			<Next onClick={() => onNext(name)} disabled={name?.length <= 0}>
				<Trans>introduction.player.next</Trans>
			</Next>
		</Dialog>
	);
};

export default PlayerDialog;
